var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"github__container"},[_c('img',{staticClass:"githubLogo",attrs:{"src":require("../../../assets/github-logo.png")}}),_vm._v(" "),_c('a',{staticClass:"github__link",attrs:{"href":"https://github.com/albertlucianto"}},[_vm._v("AlbertLucianto")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a35df7f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AboutMe/DetailDescription/GithubProfile.vue
// module id = D+mR
// module chunks = 0